import styled from "styled-components";

export const LiveMissionsWrapperStyled = styled.div`
  height: calc(100% - 110px);
`;

export const MissionNameCellStyled = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
  color: #3f7f7d;
  font-size: 14px;
  font-family: Readex Pro;
  font-weight: 400;
  line-height: 19.6px;
  word-wrap: break-word;
`;

export const VehicleTypeImgStyled = styled.img`
  width: 24px;
  height: 24px;
  object-fit: contain;
`;

export const VehicleNameStyled = styled.div`
  color: #1e1e1e;
  font-size: 14px;
  font-family: Readex Pro;
  font-weight: 300;
  line-height: 19.6px;
  word-wrap: break-word;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const VehicleFieldBodyStyled = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const UniqTextStyled = styled.div`
  display: contents;
  font-weight: 700;
`;
